export const FOUR_HOURS_MS = 14400000;
export const DEEP_REASONING_TOGGLE_NAME = 'Deep Reasoning';
